export const IUpdateCacheUseCaseType = Symbol('IUpdateCacheUseCase');
